import isEqual from 'lodash/isEqual';
import React__default from 'react';

function deepCompareEquals(a, b) {
    return isEqual(a, b);
}
function useDeepCompareMemoize(value) {
    var ref = React__default.useRef();
    if (!deepCompareEquals(value, ref.current)) {
        ref.current = value;
    }
    return ref.current;
}
function useDeepCompareEffect(callback, dependencies) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return React__default.useEffect(callback, useDeepCompareMemoize(dependencies));
}

export { useDeepCompareEffect };
//# sourceMappingURL=useDeepCompareEffect.js.map
